import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { OperatorAddPayload, OperatorEditPayload } from './operatori-institutii.interface';

@Injectable({
    providedIn: 'root'
})
export class OperatoriInstitutiiService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private getOperatorUrl = this.basePath + environment.interop.platform.nomenclatoare.operatoriInstitutii.getOperator;
    private getOperatoriUrl = this.basePath + environment.interop.platform.nomenclatoare.operatoriInstitutii.getOperatori;
    private storeOperatorUrl = this.basePath + environment.interop.platform.nomenclatoare.operatoriInstitutii.storeOperator;
    private updateOperatorUrl = this.basePath + environment.interop.platform.nomenclatoare.operatoriInstitutii.updateOperator;
    private deleteOperatorUrl = this.basePath + environment.interop.platform.nomenclatoare.operatoriInstitutii.deleteOperator;
    private getOperatoriActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.operatoriInstitutii.getOperatoriActive;
    private getOperatoriPublicUrl = this.basePath + environment.interop.platform.nomenclatoare.operatoriInstitutii.getOperatoriPublic;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.operatoriInstitutii
            .changeStatusOperatorActive;
    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.operatoriInstitutii
            .changeStatusOperatorPublic;

    constructor(private http: HttpClient) { }

    getOperator() {
        return this.http.get(this.getOperatorUrl, this.httpOptions);
    }

    getOperatori(id_directie?: number, id_compartiment?: number, name?: string) {
        let params = new HttpParams();

        if (id_directie !== undefined) {
            params = params.set('id_directie', id_directie);
        }

        if (id_compartiment !== undefined) {
            params = params.set('id_compartiment', id_compartiment);
        }

        if (name !== undefined) {
            params = params.set('name', name);
        }

        return this.http.get(this.getOperatoriUrl, { params });
    }

    storeOperator(operator: OperatorAddPayload) {
        return this.http.post(this.storeOperatorUrl, operator, this.httpOptions);
    }

    updateOperator(operator: OperatorEditPayload) {
        return this.http.put(this.updateOperatorUrl, operator, this.httpOptions);
    }

    deleteOperator(id: number) {
        return this.http.delete(this.deleteOperatorUrl + id);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }
}
